<template>
  <KekkleCard shadow="blue">
    <h1 class="text-xl font-bold dark:text-slate-200">
      {{ $t("auth.check_email") }}
      📧
    </h1>
    <p class="mb-4 dark:text-slate-200">
      {{ $t("auth.click_mail_to_verify") }}
    </p>
    <default-button @click="next">{{ $t("auth.continue") }}</default-button>
    <p
      v-if="!resendEmailSend"
      class="my-4 cursor-pointer underline dark:text-slate-200"
      @click="resendEmail"
    >
      {{ $t("auth.no_mail_try_again_here") }}
    </p>
  </KekkleCard>
  <p
    class="mx-auto mt-4 w-fit max-w-xs cursor-pointer rounded border border-red-500 p-2 text-center text-red-500 transition duration-300 hover:bg-red-500 hover:text-white"
    @click="logout()"
  >
    {{ $t("global.inputs.labels.logout") }}
  </p>
</template>
<script>
import { useAuthStore } from "@/stores/modules/auth/auth";
import { sendEmailVerification } from "firebase/auth";
import {
  setSuccessToast,
  setWarningToast,
} from "@/helpers/notifications/toast";
import DefaultButton from "@/components/Buttons/DefaultButton.vue";
import KekkleCard from "@/components/ui/KekkleCard.vue";

export default {
  name: "VerifyEmail",
  components: { DefaultButton, KekkleCard },
  setup() {
    const authStore = useAuthStore();
    return { authStore };
  },
  data() {
    return {
      resendEmailSend: false,
    };
  },
  async created() {
    try {
      await this.authStore.refreshAuthIdToken();
      this.$router.push({ name: "Group" });
    } catch {
      //
    }
  },
  methods: {
    logout() {
      this.authStore.logout();
    },
    async resendEmail() {
      try {
        await sendEmailVerification(this.authStore.firebaseAuthUser);
        setSuccessToast({ message: this.$t("auth.email_send") });
      } catch {
        setWarningToast({ message: this.$t("auth.email_not_send") });
        this.$router.push({ name: "Login" });
      } finally {
        this.resendEmailSend = true;
      }
    },
    async next() {
      await this.authStore.refreshAuthIdToken();
      this.$router.push({ name: "Group" });
    },
  },
};
</script>
